@if(personDialogDataService.personDetails(); as personDetails) {
<kendo-tabstrip (tabSelect)="selectTab($event)" class="h-100 p-2 pb-0">

	<kendo-tabstrip-tab title="Overview" [selected]="selectedTab() === 0">
		<ng-template kendoTabContent>
			<person-overview-part></person-overview-part>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab title="Engagements" [selected]="selectedTab() === 1">
		<ng-template kendoTabContent>
			<person-engagements-part [dialogBodyHeight]="dialogBodyHeight()"></person-engagements-part>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab title="Notes" [selected]="selectedTab() === 2">
		<ng-template kendoTabContent>
			<notes-editor-part [personId]="personDetails.personId"></notes-editor-part>
		</ng-template>
	</kendo-tabstrip-tab>

</kendo-tabstrip>
} @else if(isNotProdEnvironment) {
<common-message alertType='info'>
	The record for this person does not exist in the development database yet. Please go to
	programs.eforall.org to see the latest data.
</common-message>
}